import gql from 'graphql-tag';

export const RESEND_DISCLOSURE_EMAIL = gql`
  mutation ResendDisclosureEmail($input: ResendDocuSignEmailInput!) {
    resendDocuSignEmail(input: $input) {
      success
      message
    }
  }
`;

export const resendDisclosureEmailMock = {
  success: {
    data: {
      resendDocuSignEmail: {
        success: true,
        message: 'Email sent',
      },
    },
  },
  error: {
    data: {
      resendDocuSignEmail: {
        success: false,
        message: 'Error sending email',
      },
    },
  },
  failure: {
    data: {
      resendDocusignEmail: {
        success: false,
        message: 'Error sending email',
      },
    },
  },
};
